"use client";

import React from "react";
import { Button, Tooltip, TooltipTrigger, TooltipContent } from "@heroui/react";
import { useTranslation } from "react-i18next";

import { SearchIcon } from "@/components/icons";

interface SearchChatButtonProps {
  onOpenSearch: () => void;
  isDisabled: boolean;
  isCompact?: boolean;
}

export const SearchChatButton: React.FC<SearchChatButtonProps> = ({
  onOpenSearch,
  isDisabled,
  isCompact = false,
}) => {
  const { t } = useTranslation();

  const buttonContent = (
    <Button
      aria-label={t("Search Chats")}
      className={
        isCompact
          ? "btn-brand-primary min-w-0 w-10 p-2"
          : "btn-brand-primary h-[36px] w-full text-sm"
      }
      data-id="search-chat-button"
      disabled={isDisabled}
      size="sm"
      onPress={onOpenSearch}
    >
      {isCompact ? (
        <SearchIcon
          className={isDisabled ? "text-default-400" : "text-brand-secondary"}
          height={20}
          width={20}
        />
      ) : (
        <>
          <SearchIcon
            className={isDisabled ? "text-default-400" : "text-default-50"}
            height={20}
            width={20}
          />
          {t("Search Chats")}
        </>
      )}
    </Button>
  );

  // Wrap in Tooltip only for compact mode
  if (isCompact) {
    return (
      <Tooltip>
        <TooltipTrigger>{buttonContent}</TooltipTrigger>
        <TooltipContent placement="right">{t("Search Chats")}</TooltipContent>
      </Tooltip>
    );
  }

  return buttonContent;
};
